import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const Service = ({
  onChange,
  disabled,
  error,
  title,
  service,
  service_origins,
  maintenance_plans,
  ...props
}) => {

  const handleChange = event => {
    onChange(event, 'service')
  }

  const classes = useStyles();


  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>

      <FormControl className="mt-3 mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='maintenance_plan_id' >
        <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Plan de MTN</InputLabel>
        <Select native name='maintenance_plan_id'
            inputProps={{
              name:"maintenance_plan_id",
              className:"maintenance_plan_id"
            }}
            style={{minWidth: 150, fontSize: '0.75rem'}}
            onChange={handleChange}
            disabled={disabled}
            value={service.maintenance_plan_id}
            error={(error !=='' && (service.maintenance_plan_id ==='' || !service.maintenance_plan_id)) ? 'Debe completar este campo' :  false }
            input={<Input id="grouped-native-select" name='maintenance_plan_id'/>}>
            <option value="" />
            {maintenance_plans.map((maintenance_plan) => <option id={maintenance_plan.id} value={maintenance_plan.id}>{maintenance_plan.name}
          </option>)}
        </Select>
        {(error !=='' && (service.maintenance_plan_id ==='' || !service.maintenance_plan_id)) && <FormHelperText style={{color: 'red'}}>Debe completar este campo</FormHelperText>}        
      </FormControl>


      <TextField
        id="service_last_km"
        name="service_last_km"
        label="KM últ. service"
        disabled={disabled}
        error={(error !=='' && service.service_last_km ==='') ? 'Debe completar este campo' :  false }
        helperText= {(error !=='' && service.service_last_km ==='' ) ? 'Debe completar este valor' : ''}
        type="text"
        placeholder="Ingrese el kilometraje del último service"
        onChange={handleChange}
        value={service.service_last_km}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <TextField
        id="service_last_date"
        name="service_last_date"
        label="Fecha últ. service"
        disabled={disabled}
        error={(error !=='' && service.service_last_date ==='') ? 'Debe completar este campo' :  false }
        helperText= {(error !=='' && service.service_last_date ==='' ) ? 'Debe completar este valor' : ''}
        type="date"
        placeholder="Ingrese la fecha del último service"
        onChange={handleChange}
        value={service.service_last_date}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <TextField
        id="service_last_task_name"
        name="service_last_task_name"
        label="Últ. tarea service"
        disabled={true}
        type="text"
        value={service.service_last_task_name}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

	</React.Fragment>
	)

}
export default Service;
